export var SEO = {
    mainPage: {
        title: 'Quanta Technology — Tokenized Real Estate Exchange',
        description: 'Quanta Technology is the world\'s first tokenized real estate exchange. Trade, lend and earn yield on DeFi-powered real estate assets backed by $QUANTA.',
    },
    blogPage: {
        title: 'Quanta Exchange Blog - Latest News & Updates',
        description: 'Latest news, updates and insights from Quanta Exchange.',
    },
};
